import { Box, Heading } from '@99designs/emu';
import { FeaturesList } from '@99designs/marketing-ui';
import { TabId } from '../TabsMenu';

type Props = {
    inclusions: React.ReactNode[];
};

export function PackageInclusions({ inclusions }: Props) {
    return (
        <Box id={TabId.WhatYouGet}>
            <Heading appearanceLevel={4} accessibilityLevel={2}>
                {__('What you get')}
            </Heading>
            <Box paddingTop="1.5bu">
                <FeaturesList features={inclusions} />
            </Box>
        </Box>
    );
}
